import { create } from 'zustand';

const useWindowSizeStore = create((set) => ({
    width: window.innerWidth,
    height: window.innerHeight,
    windowMode: window.innerWidth < 810 ? 'mo' : 'pc',
    
    setSize: (width, height) => set((state) => {
        const windowMode = width < 810 ? 'mo' : 'pc';

        return {
            width,
            height,
            windowMode
        }
    }),
}));

export default useWindowSizeStore;